/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AppLibraryRouteImport } from './routes/_app/_library'
import { Route as AppAdminRouteRouteImport } from './routes/_app/admin/route'
import { Route as AppReadingRouteImport } from './routes/_app/reading'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppUploadRouteRouteImport } from './routes/_app/upload/route'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as ResetTokenRouteImport } from './routes/reset.$token'
import { Route as AppLibraryIndexRouteImport } from './routes/_app/_library/index'
import { Route as AppLibrarySuggestionsRouteImport } from './routes/_app/_library/suggestions'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminEmailRouteImport } from './routes/_app/admin/email'
import { Route as AppAdminInvitationsRouteImport } from './routes/_app/admin/invitations'
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin/settings'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAccountRouteImport } from './routes/_app/settings/account'
import { Route as AppSettingsDevicesRouteImport } from './routes/_app/settings/devices'
import { Route as AppSettingsKindleRouteImport } from './routes/_app/settings/kindle'
import { Route as AppSettingsKindleHistoryRouteImport } from './routes/_app/settings/kindle-history'
import { Route as AppShelvesIndexRouteImport } from './routes/_app/shelves.index'
import { Route as AppShelvesIdRouteImport } from './routes/_app/shelves.$id'
import { Route as AppUploadIndexRouteImport } from './routes/_app/upload/index'
import { Route as AppUploadInboxRouteImport } from './routes/_app/upload/inbox'
import { Route as AppLibraryAuthorsIndexRouteImport } from './routes/_app/_library/authors.index'
import { Route as AppLibraryAuthorsIdRouteImport } from './routes/_app/_library/authors.$id'
import { Route as AppLibraryPublishersIndexRouteImport } from './routes/_app/_library/publishers.index'
import { Route as AppLibraryPublishersIdRouteImport } from './routes/_app/_library/publishers.$id'
import { Route as AppLibrarySeriesIndexRouteImport } from './routes/_app/_library/series.index'
import { Route as AppLibrarySeriesIdRouteImport } from './routes/_app/_library/series.$id'
import { Route as AppLibraryTagsIndexRouteImport } from './routes/_app/_library/tags.index'
import { Route as AppLibraryTagsIdRouteImport } from './routes/_app/_library/tags.$id'
import { Route as AppAdminAuthorMappingIndexRouteImport } from './routes/_app/admin/author-mapping.index'
import { Route as AppAdminAuthorMappingAuthorIdRouteImport } from './routes/_app/admin/author-mapping.$authorId'
import { Route as AppAdminImportCalibreRouteImport } from './routes/_app/admin/import.calibre'
import { Route as AppAdminJobsIndexRouteImport } from './routes/_app/admin/jobs.index'
import { Route as AppAdminJobsJobIdRouteImport } from './routes/_app/admin/jobs.$jobId'
import { Route as AppBooksIdIndexRouteImport } from './routes/_app/books.$id.index'
import { Route as AppBooksIdEditRouteImport } from './routes/_app/books.$id.edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLibraryRoute = AppLibraryRouteImport.update({
  id: '/_library',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppReadingRoute = AppReadingRouteImport.update({
  id: '/reading',
  path: '/reading',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppUploadRouteRoute = AppUploadRouteRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetTokenRoute = ResetTokenRouteImport.update({
  id: '/reset/$token',
  path: '/reset/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLibraryIndexRoute = AppLibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppLibrarySuggestionsRoute = AppLibrarySuggestionsRouteImport.update({
  id: '/suggestions',
  path: '/suggestions',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminEmailRoute = AppAdminEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminInvitationsRoute = AppAdminInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDevicesRoute = AppSettingsDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsKindleRoute = AppSettingsKindleRouteImport.update({
  id: '/kindle',
  path: '/kindle',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsKindleHistoryRoute =
  AppSettingsKindleHistoryRouteImport.update({
    id: '/kindle-history',
    path: '/kindle-history',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppShelvesIndexRoute = AppShelvesIndexRouteImport.update({
  id: '/shelves/',
  path: '/shelves/',
  getParentRoute: () => AppRoute,
} as any)
const AppShelvesIdRoute = AppShelvesIdRouteImport.update({
  id: '/shelves/$id',
  path: '/shelves/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppUploadIndexRoute = AppUploadIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppUploadRouteRoute,
} as any)
const AppUploadInboxRoute = AppUploadInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppUploadRouteRoute,
} as any)
const AppLibraryAuthorsIndexRoute = AppLibraryAuthorsIndexRouteImport.update({
  id: '/authors/',
  path: '/authors/',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppLibraryAuthorsIdRoute = AppLibraryAuthorsIdRouteImport.update({
  id: '/authors/$id',
  path: '/authors/$id',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppLibraryPublishersIndexRoute =
  AppLibraryPublishersIndexRouteImport.update({
    id: '/publishers/',
    path: '/publishers/',
    getParentRoute: () => AppLibraryRoute,
  } as any)
const AppLibraryPublishersIdRoute = AppLibraryPublishersIdRouteImport.update({
  id: '/publishers/$id',
  path: '/publishers/$id',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppLibrarySeriesIndexRoute = AppLibrarySeriesIndexRouteImport.update({
  id: '/series/',
  path: '/series/',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppLibrarySeriesIdRoute = AppLibrarySeriesIdRouteImport.update({
  id: '/series/$id',
  path: '/series/$id',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppLibraryTagsIndexRoute = AppLibraryTagsIndexRouteImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppLibraryTagsIdRoute = AppLibraryTagsIdRouteImport.update({
  id: '/tags/$id',
  path: '/tags/$id',
  getParentRoute: () => AppLibraryRoute,
} as any)
const AppAdminAuthorMappingIndexRoute =
  AppAdminAuthorMappingIndexRouteImport.update({
    id: '/author-mapping/',
    path: '/author-mapping/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAuthorMappingAuthorIdRoute =
  AppAdminAuthorMappingAuthorIdRouteImport.update({
    id: '/author-mapping/$authorId',
    path: '/author-mapping/$authorId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminImportCalibreRoute = AppAdminImportCalibreRouteImport.update({
  id: '/import/calibre',
  path: '/import/calibre',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminJobsIndexRoute = AppAdminJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminJobsJobIdRoute = AppAdminJobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppBooksIdIndexRoute = AppBooksIdIndexRouteImport.update({
  id: '/books/$id/',
  path: '/books/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppBooksIdEditRoute = AppBooksIdEditRouteImport.update({
  id: '/books/$id/edit',
  path: '/books/$id/edit',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppLibraryIndexRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/upload': typeof AppUploadRouteRouteWithChildren
  '/reading': typeof AppReadingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset/$token': typeof ResetTokenRoute
  '/suggestions': typeof AppLibrarySuggestionsRoute
  '/admin/email': typeof AppAdminEmailRoute
  '/admin/invitations': typeof AppAdminInvitationsRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/devices': typeof AppSettingsDevicesRoute
  '/settings/kindle': typeof AppSettingsKindleRoute
  '/settings/kindle-history': typeof AppSettingsKindleHistoryRoute
  '/shelves/$id': typeof AppShelvesIdRoute
  '/upload/inbox': typeof AppUploadInboxRoute
  '/admin/': typeof AppAdminIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/shelves/': typeof AppShelvesIndexRoute
  '/upload/': typeof AppUploadIndexRoute
  '/authors/$id': typeof AppLibraryAuthorsIdRoute
  '/publishers/$id': typeof AppLibraryPublishersIdRoute
  '/series/$id': typeof AppLibrarySeriesIdRoute
  '/tags/$id': typeof AppLibraryTagsIdRoute
  '/admin/author-mapping/$authorId': typeof AppAdminAuthorMappingAuthorIdRoute
  '/admin/import/calibre': typeof AppAdminImportCalibreRoute
  '/admin/jobs/$jobId': typeof AppAdminJobsJobIdRoute
  '/books/$id/edit': typeof AppBooksIdEditRoute
  '/authors/': typeof AppLibraryAuthorsIndexRoute
  '/publishers/': typeof AppLibraryPublishersIndexRoute
  '/series/': typeof AppLibrarySeriesIndexRoute
  '/tags/': typeof AppLibraryTagsIndexRoute
  '/admin/author-mapping/': typeof AppAdminAuthorMappingIndexRoute
  '/admin/jobs/': typeof AppAdminJobsIndexRoute
  '/books/$id/': typeof AppBooksIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppLibraryIndexRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/reading': typeof AppReadingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset/$token': typeof ResetTokenRoute
  '/suggestions': typeof AppLibrarySuggestionsRoute
  '/admin/email': typeof AppAdminEmailRoute
  '/admin/invitations': typeof AppAdminInvitationsRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/devices': typeof AppSettingsDevicesRoute
  '/settings/kindle': typeof AppSettingsKindleRoute
  '/settings/kindle-history': typeof AppSettingsKindleHistoryRoute
  '/shelves/$id': typeof AppShelvesIdRoute
  '/upload/inbox': typeof AppUploadInboxRoute
  '/admin': typeof AppAdminIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/shelves': typeof AppShelvesIndexRoute
  '/upload': typeof AppUploadIndexRoute
  '/authors/$id': typeof AppLibraryAuthorsIdRoute
  '/publishers/$id': typeof AppLibraryPublishersIdRoute
  '/series/$id': typeof AppLibrarySeriesIdRoute
  '/tags/$id': typeof AppLibraryTagsIdRoute
  '/admin/author-mapping/$authorId': typeof AppAdminAuthorMappingAuthorIdRoute
  '/admin/import/calibre': typeof AppAdminImportCalibreRoute
  '/admin/jobs/$jobId': typeof AppAdminJobsJobIdRoute
  '/books/$id/edit': typeof AppBooksIdEditRoute
  '/authors': typeof AppLibraryAuthorsIndexRoute
  '/publishers': typeof AppLibraryPublishersIndexRoute
  '/series': typeof AppLibrarySeriesIndexRoute
  '/tags': typeof AppLibraryTagsIndexRoute
  '/admin/author-mapping': typeof AppAdminAuthorMappingIndexRoute
  '/admin/jobs': typeof AppAdminJobsIndexRoute
  '/books/$id': typeof AppBooksIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/_app/admin': typeof AppAdminRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/upload': typeof AppUploadRouteRouteWithChildren
  '/_app/_library': typeof AppLibraryRouteWithChildren
  '/_app/reading': typeof AppReadingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset/$token': typeof ResetTokenRoute
  '/_app/_library/suggestions': typeof AppLibrarySuggestionsRoute
  '/_app/admin/email': typeof AppAdminEmailRoute
  '/_app/admin/invitations': typeof AppAdminInvitationsRoute
  '/_app/admin/settings': typeof AppAdminSettingsRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/settings/account': typeof AppSettingsAccountRoute
  '/_app/settings/devices': typeof AppSettingsDevicesRoute
  '/_app/settings/kindle': typeof AppSettingsKindleRoute
  '/_app/settings/kindle-history': typeof AppSettingsKindleHistoryRoute
  '/_app/shelves/$id': typeof AppShelvesIdRoute
  '/_app/upload/inbox': typeof AppUploadInboxRoute
  '/_app/_library/': typeof AppLibraryIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/shelves/': typeof AppShelvesIndexRoute
  '/_app/upload/': typeof AppUploadIndexRoute
  '/_app/_library/authors/$id': typeof AppLibraryAuthorsIdRoute
  '/_app/_library/publishers/$id': typeof AppLibraryPublishersIdRoute
  '/_app/_library/series/$id': typeof AppLibrarySeriesIdRoute
  '/_app/_library/tags/$id': typeof AppLibraryTagsIdRoute
  '/_app/admin/author-mapping/$authorId': typeof AppAdminAuthorMappingAuthorIdRoute
  '/_app/admin/import/calibre': typeof AppAdminImportCalibreRoute
  '/_app/admin/jobs/$jobId': typeof AppAdminJobsJobIdRoute
  '/_app/books/$id/edit': typeof AppBooksIdEditRoute
  '/_app/_library/authors/': typeof AppLibraryAuthorsIndexRoute
  '/_app/_library/publishers/': typeof AppLibraryPublishersIndexRoute
  '/_app/_library/series/': typeof AppLibrarySeriesIndexRoute
  '/_app/_library/tags/': typeof AppLibraryTagsIndexRoute
  '/_app/admin/author-mapping/': typeof AppAdminAuthorMappingIndexRoute
  '/_app/admin/jobs/': typeof AppAdminJobsIndexRoute
  '/_app/books/$id/': typeof AppBooksIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/setup'
    | '/admin'
    | '/settings'
    | '/upload'
    | '/reading'
    | '/invite/$token'
    | '/reset/$token'
    | '/suggestions'
    | '/admin/email'
    | '/admin/invitations'
    | '/admin/settings'
    | '/admin/users'
    | '/settings/account'
    | '/settings/devices'
    | '/settings/kindle'
    | '/settings/kindle-history'
    | '/shelves/$id'
    | '/upload/inbox'
    | '/admin/'
    | '/settings/'
    | '/shelves/'
    | '/upload/'
    | '/authors/$id'
    | '/publishers/$id'
    | '/series/$id'
    | '/tags/$id'
    | '/admin/author-mapping/$authorId'
    | '/admin/import/calibre'
    | '/admin/jobs/$jobId'
    | '/books/$id/edit'
    | '/authors/'
    | '/publishers/'
    | '/series/'
    | '/tags/'
    | '/admin/author-mapping/'
    | '/admin/jobs/'
    | '/books/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/setup'
    | '/reading'
    | '/invite/$token'
    | '/reset/$token'
    | '/suggestions'
    | '/admin/email'
    | '/admin/invitations'
    | '/admin/settings'
    | '/admin/users'
    | '/settings/account'
    | '/settings/devices'
    | '/settings/kindle'
    | '/settings/kindle-history'
    | '/shelves/$id'
    | '/upload/inbox'
    | '/admin'
    | '/settings'
    | '/shelves'
    | '/upload'
    | '/authors/$id'
    | '/publishers/$id'
    | '/series/$id'
    | '/tags/$id'
    | '/admin/author-mapping/$authorId'
    | '/admin/import/calibre'
    | '/admin/jobs/$jobId'
    | '/books/$id/edit'
    | '/authors'
    | '/publishers'
    | '/series'
    | '/tags'
    | '/admin/author-mapping'
    | '/admin/jobs'
    | '/books/$id'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/setup'
    | '/_app/admin'
    | '/_app/settings'
    | '/_app/upload'
    | '/_app/_library'
    | '/_app/reading'
    | '/invite/$token'
    | '/reset/$token'
    | '/_app/_library/suggestions'
    | '/_app/admin/email'
    | '/_app/admin/invitations'
    | '/_app/admin/settings'
    | '/_app/admin/users'
    | '/_app/settings/account'
    | '/_app/settings/devices'
    | '/_app/settings/kindle'
    | '/_app/settings/kindle-history'
    | '/_app/shelves/$id'
    | '/_app/upload/inbox'
    | '/_app/_library/'
    | '/_app/admin/'
    | '/_app/settings/'
    | '/_app/shelves/'
    | '/_app/upload/'
    | '/_app/_library/authors/$id'
    | '/_app/_library/publishers/$id'
    | '/_app/_library/series/$id'
    | '/_app/_library/tags/$id'
    | '/_app/admin/author-mapping/$authorId'
    | '/_app/admin/import/calibre'
    | '/_app/admin/jobs/$jobId'
    | '/_app/books/$id/edit'
    | '/_app/_library/authors/'
    | '/_app/_library/publishers/'
    | '/_app/_library/series/'
    | '/_app/_library/tags/'
    | '/_app/admin/author-mapping/'
    | '/_app/admin/jobs/'
    | '/_app/books/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SetupRoute: typeof SetupRoute
  InviteTokenRoute: typeof InviteTokenRoute
  ResetTokenRoute: typeof ResetTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_library': {
      id: '/_app/_library'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppLibraryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reading': {
      id: '/_app/reading'
      path: '/reading'
      fullPath: '/reading'
      preLoaderRoute: typeof AppReadingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/upload': {
      id: '/_app/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof AppUploadRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset/$token': {
      id: '/reset/$token'
      path: '/reset/$token'
      fullPath: '/reset/$token'
      preLoaderRoute: typeof ResetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_library/': {
      id: '/_app/_library/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppLibraryIndexRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/_library/suggestions': {
      id: '/_app/_library/suggestions'
      path: '/suggestions'
      fullPath: '/suggestions'
      preLoaderRoute: typeof AppLibrarySuggestionsRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/email': {
      id: '/_app/admin/email'
      path: '/email'
      fullPath: '/admin/email'
      preLoaderRoute: typeof AppAdminEmailRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/invitations': {
      id: '/_app/admin/invitations'
      path: '/invitations'
      fullPath: '/admin/invitations'
      preLoaderRoute: typeof AppAdminInvitationsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/settings': {
      id: '/_app/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/account': {
      id: '/_app/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppSettingsAccountRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/devices': {
      id: '/_app/settings/devices'
      path: '/devices'
      fullPath: '/settings/devices'
      preLoaderRoute: typeof AppSettingsDevicesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/kindle': {
      id: '/_app/settings/kindle'
      path: '/kindle'
      fullPath: '/settings/kindle'
      preLoaderRoute: typeof AppSettingsKindleRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/kindle-history': {
      id: '/_app/settings/kindle-history'
      path: '/kindle-history'
      fullPath: '/settings/kindle-history'
      preLoaderRoute: typeof AppSettingsKindleHistoryRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/shelves/': {
      id: '/_app/shelves/'
      path: '/shelves'
      fullPath: '/shelves/'
      preLoaderRoute: typeof AppShelvesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shelves/$id': {
      id: '/_app/shelves/$id'
      path: '/shelves/$id'
      fullPath: '/shelves/$id'
      preLoaderRoute: typeof AppShelvesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/upload/': {
      id: '/_app/upload/'
      path: '/'
      fullPath: '/upload/'
      preLoaderRoute: typeof AppUploadIndexRouteImport
      parentRoute: typeof AppUploadRouteRoute
    }
    '/_app/upload/inbox': {
      id: '/_app/upload/inbox'
      path: '/inbox'
      fullPath: '/upload/inbox'
      preLoaderRoute: typeof AppUploadInboxRouteImport
      parentRoute: typeof AppUploadRouteRoute
    }
    '/_app/_library/authors/': {
      id: '/_app/_library/authors/'
      path: '/authors'
      fullPath: '/authors/'
      preLoaderRoute: typeof AppLibraryAuthorsIndexRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/_library/authors/$id': {
      id: '/_app/_library/authors/$id'
      path: '/authors/$id'
      fullPath: '/authors/$id'
      preLoaderRoute: typeof AppLibraryAuthorsIdRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/_library/publishers/': {
      id: '/_app/_library/publishers/'
      path: '/publishers'
      fullPath: '/publishers/'
      preLoaderRoute: typeof AppLibraryPublishersIndexRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/_library/publishers/$id': {
      id: '/_app/_library/publishers/$id'
      path: '/publishers/$id'
      fullPath: '/publishers/$id'
      preLoaderRoute: typeof AppLibraryPublishersIdRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/_library/series/': {
      id: '/_app/_library/series/'
      path: '/series'
      fullPath: '/series/'
      preLoaderRoute: typeof AppLibrarySeriesIndexRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/_library/series/$id': {
      id: '/_app/_library/series/$id'
      path: '/series/$id'
      fullPath: '/series/$id'
      preLoaderRoute: typeof AppLibrarySeriesIdRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/_library/tags/': {
      id: '/_app/_library/tags/'
      path: '/tags'
      fullPath: '/tags/'
      preLoaderRoute: typeof AppLibraryTagsIndexRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/_library/tags/$id': {
      id: '/_app/_library/tags/$id'
      path: '/tags/$id'
      fullPath: '/tags/$id'
      preLoaderRoute: typeof AppLibraryTagsIdRouteImport
      parentRoute: typeof AppLibraryRoute
    }
    '/_app/admin/author-mapping/': {
      id: '/_app/admin/author-mapping/'
      path: '/author-mapping'
      fullPath: '/admin/author-mapping/'
      preLoaderRoute: typeof AppAdminAuthorMappingIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/author-mapping/$authorId': {
      id: '/_app/admin/author-mapping/$authorId'
      path: '/author-mapping/$authorId'
      fullPath: '/admin/author-mapping/$authorId'
      preLoaderRoute: typeof AppAdminAuthorMappingAuthorIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/import/calibre': {
      id: '/_app/admin/import/calibre'
      path: '/import/calibre'
      fullPath: '/admin/import/calibre'
      preLoaderRoute: typeof AppAdminImportCalibreRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/jobs/': {
      id: '/_app/admin/jobs/'
      path: '/jobs'
      fullPath: '/admin/jobs/'
      preLoaderRoute: typeof AppAdminJobsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/jobs/$jobId': {
      id: '/_app/admin/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/admin/jobs/$jobId'
      preLoaderRoute: typeof AppAdminJobsJobIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/books/$id/': {
      id: '/_app/books/$id/'
      path: '/books/$id'
      fullPath: '/books/$id/'
      preLoaderRoute: typeof AppBooksIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/books/$id/edit': {
      id: '/_app/books/$id/edit'
      path: '/books/$id/edit'
      fullPath: '/books/$id/edit'
      preLoaderRoute: typeof AppBooksIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAdminRouteRouteChildren {
  AppAdminEmailRoute: typeof AppAdminEmailRoute
  AppAdminInvitationsRoute: typeof AppAdminInvitationsRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminAuthorMappingAuthorIdRoute: typeof AppAdminAuthorMappingAuthorIdRoute
  AppAdminImportCalibreRoute: typeof AppAdminImportCalibreRoute
  AppAdminJobsJobIdRoute: typeof AppAdminJobsJobIdRoute
  AppAdminAuthorMappingIndexRoute: typeof AppAdminAuthorMappingIndexRoute
  AppAdminJobsIndexRoute: typeof AppAdminJobsIndexRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminEmailRoute: AppAdminEmailRoute,
  AppAdminInvitationsRoute: AppAdminInvitationsRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminAuthorMappingAuthorIdRoute: AppAdminAuthorMappingAuthorIdRoute,
  AppAdminImportCalibreRoute: AppAdminImportCalibreRoute,
  AppAdminJobsJobIdRoute: AppAdminJobsJobIdRoute,
  AppAdminAuthorMappingIndexRoute: AppAdminAuthorMappingIndexRoute,
  AppAdminJobsIndexRoute: AppAdminJobsIndexRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute
  AppSettingsDevicesRoute: typeof AppSettingsDevicesRoute
  AppSettingsKindleRoute: typeof AppSettingsKindleRoute
  AppSettingsKindleHistoryRoute: typeof AppSettingsKindleHistoryRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSettingsDevicesRoute: AppSettingsDevicesRoute,
  AppSettingsKindleRoute: AppSettingsKindleRoute,
  AppSettingsKindleHistoryRoute: AppSettingsKindleHistoryRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppUploadRouteRouteChildren {
  AppUploadInboxRoute: typeof AppUploadInboxRoute
  AppUploadIndexRoute: typeof AppUploadIndexRoute
}

const AppUploadRouteRouteChildren: AppUploadRouteRouteChildren = {
  AppUploadInboxRoute: AppUploadInboxRoute,
  AppUploadIndexRoute: AppUploadIndexRoute,
}

const AppUploadRouteRouteWithChildren = AppUploadRouteRoute._addFileChildren(
  AppUploadRouteRouteChildren,
)

interface AppLibraryRouteChildren {
  AppLibrarySuggestionsRoute: typeof AppLibrarySuggestionsRoute
  AppLibraryIndexRoute: typeof AppLibraryIndexRoute
  AppLibraryAuthorsIdRoute: typeof AppLibraryAuthorsIdRoute
  AppLibraryPublishersIdRoute: typeof AppLibraryPublishersIdRoute
  AppLibrarySeriesIdRoute: typeof AppLibrarySeriesIdRoute
  AppLibraryTagsIdRoute: typeof AppLibraryTagsIdRoute
  AppLibraryAuthorsIndexRoute: typeof AppLibraryAuthorsIndexRoute
  AppLibraryPublishersIndexRoute: typeof AppLibraryPublishersIndexRoute
  AppLibrarySeriesIndexRoute: typeof AppLibrarySeriesIndexRoute
  AppLibraryTagsIndexRoute: typeof AppLibraryTagsIndexRoute
}

const AppLibraryRouteChildren: AppLibraryRouteChildren = {
  AppLibrarySuggestionsRoute: AppLibrarySuggestionsRoute,
  AppLibraryIndexRoute: AppLibraryIndexRoute,
  AppLibraryAuthorsIdRoute: AppLibraryAuthorsIdRoute,
  AppLibraryPublishersIdRoute: AppLibraryPublishersIdRoute,
  AppLibrarySeriesIdRoute: AppLibrarySeriesIdRoute,
  AppLibraryTagsIdRoute: AppLibraryTagsIdRoute,
  AppLibraryAuthorsIndexRoute: AppLibraryAuthorsIndexRoute,
  AppLibraryPublishersIndexRoute: AppLibraryPublishersIndexRoute,
  AppLibrarySeriesIndexRoute: AppLibrarySeriesIndexRoute,
  AppLibraryTagsIndexRoute: AppLibraryTagsIndexRoute,
}

const AppLibraryRouteWithChildren = AppLibraryRoute._addFileChildren(
  AppLibraryRouteChildren,
)

interface AppRouteChildren {
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppUploadRouteRoute: typeof AppUploadRouteRouteWithChildren
  AppLibraryRoute: typeof AppLibraryRouteWithChildren
  AppReadingRoute: typeof AppReadingRoute
  AppShelvesIdRoute: typeof AppShelvesIdRoute
  AppShelvesIndexRoute: typeof AppShelvesIndexRoute
  AppBooksIdEditRoute: typeof AppBooksIdEditRoute
  AppBooksIdIndexRoute: typeof AppBooksIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppUploadRouteRoute: AppUploadRouteRouteWithChildren,
  AppLibraryRoute: AppLibraryRouteWithChildren,
  AppReadingRoute: AppReadingRoute,
  AppShelvesIdRoute: AppShelvesIdRoute,
  AppShelvesIndexRoute: AppShelvesIndexRoute,
  AppBooksIdEditRoute: AppBooksIdEditRoute,
  AppBooksIdIndexRoute: AppBooksIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SetupRoute: SetupRoute,
  InviteTokenRoute: InviteTokenRoute,
  ResetTokenRoute: ResetTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
